import { render, staticRenderFns } from "./PersonalInformationRow.vue?vue&type=template&id=32a31e0c&scoped=true&"
import script from "./PersonalInformationRow.vue?vue&type=script&lang=js&"
export * from "./PersonalInformationRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInformationRow.vue?vue&type=style&index=0&id=32a31e0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a31e0c",
  null
  
)

export default component.exports